var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFixedTime = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-69 -416)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,0A10,10,0,1,1,0,10,10,10,0,0,1,10,0Z",
    transform: "translate(69 416)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9.6,8.4V2.5H8.4v8.2L13.5,7l-.6-.9Z",
    transform: "translate(70 417)",
    fill: "#fff"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFixedTime);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/fixed-time.f99dd291dd0de9e325843b6656cfa3ed.svg";